import { AbstractMessageBarData } from "@lib/titan2-slingo/dist/game/model/data/abstract/AbstractMessageBarData";
export class GameMessageBarData extends AbstractMessageBarData {
    setDefaultValues() {
        super.setDefaultValues();
        this.idleMessages = 6;
    }
}
//# sourceMappingURL=GameMessageBarData.js.map